import { IFlightClassResponse } from '@shared/shared/interfaces/travel-flight.interfaces';

export const CLEAR_FLIGHT_CLASSES = '[Flight Classes] Clear flight classes';
export const GET_FLIGHT_CLASSES = '[Flight Classes] Get flight classes';
export const GET_FLIGHT_CLASSES_SUCCESS = '[Flight Classes] Get flight classes success';

export class ClearFlightClasses {
  readonly type = CLEAR_FLIGHT_CLASSES;
}

export class GetFlightClasses {
  readonly type = GET_FLIGHT_CLASSES;
}

export class GetFlightClassesSuccess {
  readonly type = GET_FLIGHT_CLASSES_SUCCESS;
  constructor(public payload: { results: Array<IFlightClassResponse> }) {}
}

export type FlightClassesActions = GetFlightClasses | GetFlightClassesSuccess | ClearFlightClasses;
